import React, { useCallback, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import {
	getForgePublicToken,
	getModelData,
	getModelTranslationStatus,
	setBuildingTranslationStatus,
	updateModelThumbnail,
} from "../../../../../actions";
import { alertTypeConstants } from "../../../../../constants/constants";
import localize, { LocKeys } from "../../../../../constants/localizations";
import { setViewerInstance } from "../../../../../hooks/useViewer";

/**
 * FORGE viewer - AUTODESK FORGE
 * @param {*} props
 * @returns
 */
const RevitForgeViewer = (props) => {
	const {
		enableResize = false,
		forgeAuth,
		viewerUrn,
		// buildingTranslationStatus,
		//actions
		getForgePublicToken,
		getModelTranslationStatus,
		setBuildingTranslationStatus,
		getModelData,
	} = props;

	//const forgeAuth = props.forgeAuth && props.forgeAuth;
	let Autodesk = window.Autodesk;
	const myViewer = React.useRef();
	const viewer = React.useRef();

	const options = useMemo(() => {
		if (forgeAuth?.access_token)
			return {
				env: "AutodeskProduction",
				api: "derivativeV2_EU", // TODO: for models uploaded to EMEA change this option to 'derivativeV2_EU'
				accessToken: forgeAuth.access_token,
			};

		return null;
	}, [forgeAuth]);
	//let documentId = "urn:" + viewerUrn;

	const get3DModel = useCallback(
		(htmlElement) => {
			if (viewerUrn && forgeAuth?.access_token) {
				getModelTranslationStatus(viewerUrn, forgeAuth?.access_token)
					.then((res) => {
						if (res.status === alertTypeConstants.SUCCESS) {
							try {
								viewer.current = new Autodesk.Viewing.GuiViewer3D(htmlElement);
								viewer.current.start();

								setViewerInstance(viewer.current);

								Autodesk.Viewing.Document.load(
									"urn:" + viewerUrn,
									onDocumentLoadSuccess,
									onDocumentLoadFailure
								);
							} catch (error) {
								console.log({ error });
							}
						} else if (
							res.status === alertTypeConstants.FAILED ||
							!!res?.diagnostic
						) {
							setBuildingTranslationStatus(alertTypeConstants.FAILED);
							myViewer.current.innerHTML = `
					<div  class="viewer--forge__message text-center">
						<p>${localize(LocKeys.FAILED_MODEL_MESSAGE)}.</p>
					</div>
				    `;
						} else {
							setBuildingTranslationStatus("translating");
							myViewer.current.innerHTML = `
					<div  class="viewer--forge__message text-center">
						<span class="loading-icon mx-auto"></span>
						<span class="loading-icon mx-auto"></span>
						<p>${localize(LocKeys.TRANSLATING_MODEL)}.</p>
					</div>
				    `;
							setTimeout(() => {
								get3DModel(htmlElement);
							}, 5000);
						}
					})
					.catch((err) => {
						try {
							onDocumentLoadFailure(err);
						} catch (error) {
							console.log({ error });
						}
					});
			}
		},
		[
			Autodesk.Viewing.Document,
			Autodesk.Viewing.GuiViewer3D,
			forgeAuth,
			getModelTranslationStatus,
			setBuildingTranslationStatus,
			viewerUrn,
		]
	);

	useEffect(() => {
		getForgePublicToken();
	}, [getForgePublicToken]);

	useEffect(() => {
		if (viewer.current) {
			viewer.current.resize();
			viewer.current.fitToView();
		}
	}, [enableResize]);

	useEffect(() => {
		if (options) {
			try {
				Autodesk.Viewing.Initializer(options || {}, function () {
					var htmlElement = myViewer.current;
					if (htmlElement) {
						get3DModel(htmlElement);
					}
				}).catch((err) => console.error(err));
			} catch (error) {
				console.log({ error });
			}
		}
		return () => {
			setBuildingTranslationStatus(null);
		};
	}, [viewerUrn, options, Autodesk.Viewing, get3DModel]);
	// Run this when the page is loaded

	/**
	 * Autodesk.Viewing.Document.load() success callback.
	 * Proceeds with model initialization.
	 */
	function onDocumentLoadSuccess(doc) {
		var viewable = doc.getRoot().getDefaultGeometry();
		if (viewable) {
			viewer.current.loadExtension("Autodesk.AEC.LevelsExtension")
			viewer.current
				?.loadDocumentNode(doc, viewable)
				.then(function (result) {
					// if (buildingTranslationStatus === "translating") {
					// 	getModelData(viewerUrn);
					// 	// setBuildingTranslationStatus("success");
					// }
					//	getModelProperties();
					setBuildingTranslationStatus("success");
					getModelData(viewerUrn);
				})
				.catch(function (err) {
					console.log("Viewable failed to load.");
					console.log(err);
				});
		}
	}

	/**
	 * Autodesk.Viewing.Document.load() failure callback.
	 */
	function onDocumentLoadFailure(viewerErrorCode) {
		console.error("onDocumentLoadFailure() - errorCode: " + viewerErrorCode);
		myViewer.current.innerHTML = `<p  class="viewer--forge__message" >Translation in progress... Error!</p>`;
	}

	return <div className="viewer--forge" ref={myViewer}></div>;
};

const MapStateToProps = (state) => {
	return {
		forgeAuth: state.getIn(["building", "building", "forgeAuth"]),
		translationStatus: state.getIn(["building", "buildingViewer", "translationStatus"]),
	};
};

export default connect(MapStateToProps, {
	getForgePublicToken,
	getModelTranslationStatus,
	updateModelThumbnail,
	getModelData,
	setBuildingTranslationStatus,
})(RevitForgeViewer);
